<template>
  <v-container fluid>
    <back-btn />
    <pst-form
      :township_id="$route.params.township_id"
      :familyMemberDataEach="presumptiveDataEach"
      :contactData="contactEachData"
      @emitPresumptiveData="createPresumptive"
    />
   
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import PstForm from "@/components/presumptive/PstForm.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
import loaderObj from "@/components/notification/service/loader.js";

export default {
  components: {
    PstForm,
    BackBtn,
  },
  created() {
    if (this.paramTypes.type == "Family") {
      this.$store.dispatch(
        "Presumptive/getPresumptiveEach",
        this.paramTypes.family_member_id
      );
    } else if (this.paramTypes.type == "Followup") {
      this.$store.dispatch(
        "Presumptive/setPresumptiveEachByParam",
        this.paramTypes
      );
    }
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveDataEach"]),
    paramTypes() {
      return JSON.parse(this.$route.params.type);
    },
  },

  methods: {
    createPresumptive(data) {
      let loader = this.$loading.show(loaderObj);
      this.$store.dispatch("Presumptive/createPresumptive", data).then(() => {
        loader.hide()
      });
    },
  },
};
</script>
